import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import { Button, Card, CardBody, Col, Container, Row} from "reactstrap"
import { Link } from "react-router-dom"
import { BaseUrl } from "../../helpers/Baseurl"
import { AvForm,AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import Select from "react-select";
import default_img from '../../assets/images/noimg.jpeg'
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const customStyles = {
    overlay: {
        marginTop: '70px'
    }
}

const FilterOptions = [
  { 
		label: "Filter Options",
		options: [
              { label: "Name", value: '1' },        
		]
	}
]


class Locations extends Component {
  constructor(props) {
    super(props)
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 1, 'read' )){
      this.props.history.push('/dashboard')
    }
    this.state = {
      location_id:"",
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",
      locations: [],
      page:1,
      sizePerPage:20,
      totalSize:0,
      breadcrumbItems : [
        { title : "Planmans", link : "/dashboard" },
        { title : "locations", link : "#" },
      ],
      selectedFilterOptions: { label: "Filter By ", value: null },
      filter_option:"",
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

    this.handleLocationClicks = this.handleLocationClicks.bind(this)
    this.handleFilterSubmit = this.handleFilterSubmit.bind(this)
    this.clearFilter = this.clearFilter.bind(this)
  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }

  componentDidMount(){
    document.title = `Locations | Planmans`
  }

  async loadData(url , sizePerPage, page , searchText){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(url,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                this.setState(()=>({ locations: data.results, totalSize:data.count , page:page, sizePerPage, searchText }))
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 

  }

  handleLocationClicks = id => { 
    const requestOptions = {
      method: 'DELETE',
  
      };
        fetch(`${BaseUrl}/api/locations/location/locations/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    let new_page = this.state.page
                    if(this.state.locations.length < 2){
                      new_page = new_page>1? new_page-1:1
                    }
                    let url = `${BaseUrl}/api/locations/location/locations/?size=${this.state.sizePerPage}&page=${new_page}`
                    url = this.state.searchText && this.state.searchText !== "" ? url+`&search=${this.state.searchText}`: url
                    this.loadData(url , this.state.sizePerPage, new_page , this.state.searchText)
                    this.setState({
                      location_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Your Place has been deleted."
                      })    
                  }
              }
          )
  }
  handleFilterSubmit(e, values){
    const {sizePerPage, selectedFilterOptions } = this.state
    let filter_option = ""
    if(selectedFilterOptions.value === '1'){
      
      filter_option = `&search=${values.name}`
      let url = `${BaseUrl}/api/locations/location/locations/?size=${sizePerPage}&page=1${filter_option}` 
      this.loadData(url , sizePerPage, 1 , "")
   

    }
    this.setState({filter_option})

  }

  clearFilter(){
    let selectedFilterOptions={ label: "Filter By ", value: null }
    this.setState({selectedFilterOptions, filter_option:""})
    let url = `${BaseUrl}/api/locations/location/locations/?size=${this.state.sizePerPage}&page=1`
    this.loadData(url , this.state.sizePerPage, 1 , "")
  }

  handleTableChange = (type, { page, sizePerPage, searchText }) => {
    setTimeout(() => {
      let new_page = page
      let url = `${BaseUrl}/api/locations/location/locations/?size=${sizePerPage}&page=${new_page}`
      if (this.state.filter_option !== ""){
        url = `${BaseUrl}/api/locations/location/locations/?size=${sizePerPage}&page=${new_page}${this.state.filter_option}`
      }
      this.loadData(url , sizePerPage, new_page , searchText)
    }, 1000);
  }


  render() {

    const { page, locations, sizePerPage, totalSize, selectedFilterOptions } = this.state

    //pagination customization
    const pageOptions = {
      page: page,
      sizePerPage: sizePerPage,
      totalSize: totalSize, // replace later with size(Order),
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const locationsColumns = [
      {
        dataField: "id",
        text: "ID",
        formatter: (cellContent, row) => (
          `L-${row.id+100}`    
        )
      },
      {
        dataField: "images",
        text: "Image",
        isDummyField: true,
        formatter: (cellContent, row) => (
          row.image.length === 0?
          <img className="rounded avatar-sm" src={default_img} alt={row.name} /> :
          <img className="rounded avatar-sm" src={BaseUrl+row.image[0].image} onClick={() => this.setState({ isFits: true, img_src:BaseUrl+row.image[0].image, img_name:row.name  })} alt={row.name}/>
          )

      },
      {
        dataField: "name",
        text: "Location",
        sort: true,
        formatter: (cellContent, row) => (
          has_Permission(this.obj.user, 1, 'edit') ?
            <a 
              href={`/edit-location/${row.id}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="me-3 text-dark"
            >
              {row.name}
            </a>
          : cellContent
        )
      }
      ,
      {
        dataField: "zip_code",
        text: "ZIP Code",
      },
      {
        dataField: "parent",
        text: "Destination",
        formatter: (cellContent, row) => (
                  row.parent?row.parent.name:<i className="fas fa-check"></i>),
        align: 'center',
        headerAlign: 'center', 
      },
      {
        dataField: "tree_id",
        text: "Place",
        formatter: (cellContent, row) => (
                  row.parent? <i className="fas fa-check"></i>:<i className="fas fa-times"></i>),
        align: 'center',
        headerAlign: 'center',
      },   
      {
        dataField: "state_level",
        text: "State Level",
        formatter: (cellContent, row) => (
            cellContent? <i className="fas fa-check"></i>:<i className="fas fa-times"></i>),
        align: 'center',
        headerAlign: 'center',
      },     
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        Style: { float: 'left' },
        formatter: (cellContent, row) => (
          <React.Fragment>
            <Link to={`/location/${row.id}`} className="me-3 text-secondary"><i className="mdi mdi-eye font-size-18"></i></Link>
            {has_Permission(this.obj.user, 1, 'edit' )?
            <Link to="#" onClick={() => this.setState({ alert_confirm: true, location_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
            :null}
            </React.Fragment>
        ),
      },
    ]

    return (

      <React.Fragment>
        <div className="page-content">
          
          <Container fluid>
          <Breadcrumbs title="All locations" breadcrumbItems={this.state.breadcrumbItems} />
          {this.state.isFits ? (
                  <Lightbox
                    reactModalStyle = {customStyles}
                    mainSrc={this.state.img_src}
                    enableZoom={false}
                    imageCaption={
                      `Image : ${this.state.img_name}`
                    }
                    onCloseRequest={() => this.setState({ isFits: false })}
                  />):null}
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={locations}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={locations}
                          columns={locationsColumns}
                          remote={{ filter: true, pagination: true, sort: true, cellEdit: true }}
                          bootstrap4
                          search
                        >
                          
                          {toolkitProps => (
                            <React.Fragment>
                              
                              <Row className="mb-2">
                              <Col sm="9">
                                  <Row>
                                    <Col sm="3">
                                      <div className="mb-3 search-box" style={{borderRadius: "30px"}}>
                                          <Select  
                                              value= {selectedFilterOptions}
                                              onChange={(e) => this.setState({selectedFilterOptions: e})}
                                              options={FilterOptions}
                                              classNamePrefix="select2-selection"
                                          />
                                      </div>
                                    </Col>
                                    <Col sm="9">
                                      <AvForm className="needs-validation" onValidSubmit={this.handleFilterSubmit} >
                                        <Row>
                                          <Col sm="12">
                                            {selectedFilterOptions.value?
                                            <Row>
                                              {selectedFilterOptions.value==="1"?
                                              (
                                                <Col md="6">
                                                  <div className="search-box mb-3">
                                                    <div className="position-relative">
                                                      <AvField
                                                        name="name"
                                                        placeholder={"Name"}
                                                        type="text"
                                                        errorMessage={"Enter Name"}
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="name"
                                                      />
                                                    </div>
                                                  </div>

                                                </Col>
                                                
                                              ): null }
                                              <Col md="6">
                                                <div className="mb-2">
                                                  <Button type="submit" color="primary" className="btn-rounded me-1">
                                                  <i className="mdi mdi-filter-outline me-1" />
                                                    Apply Filter
                                                  </Button>{" "}
                                                  {this.state.filter_option!== ""?
                                                    <Button type="button" color="secondary" onClick={this.clearFilter} className="btn-rounded me-1">
                                                    <i className="mdi mdi-close me-1" />{" "}
                                                      Clear
                                                    </Button>
                                                  :null}
                                                </div>
                                              </Col> 
                                              
                                            </Row>
                                            :null}
                                
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </Col>

                                  </Row>   

                                </Col>
                                <Col sm="3">
                                  <div className="text-sm-end">
                                    {has_Permission(this.obj?.user, 1, 'create' )?
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() => this.props.history.push("/new-location")}
                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      Add Location
                                    </Button>
                                    :null}
                                  </div>
                                </Col>
                              </Row>
                              <div className="table-responsive">

                                <BootstrapTable
                                  remote
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  headerWrapperClasses={"table-light"}
                                  columns = {locationsColumns}
                                  onTableChange={ this.handleTableChange }
                                />
                                
                              </div>
                              <Row>
                                <Col sm='6'>
                                  <div className="pagination pagination-rounded mb-2">
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                                <Col sm='6'>
                                  <div className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                </Col>
                              </Row>
                              {this.state.alert_confirm ? (
                                <SweetAlert
                                title="Are you sure?"
                                warning
                                showCancel
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="danger"
                                onConfirm={() => this.handleLocationClicks(this.state.location_id)}
                                onCancel={() =>
                                    this.setState({
                                        alert_confirm: false,
                                        location_id:"",

                                    })
                                  }
                                  >
                                  You won't be able to revert this!
                                  </SweetAlert>
                              ) : null}

                              {this.state.success_confirm ? (
                                <SweetAlert
                                success
                                title={this.state.dynamic_title}
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="danger"
                                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                                >
                                  {this.state.dynamic_description}
                                </SweetAlert>
                              )
                              : null
                             }
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Locations